import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { WEB_SERVICE_MIMS, graphicDataColor1 } from "../../../config/constants";
// Components
import { RangeDatesDiv, RangeDatesLabel, DateInputDiv, DateInput } from "./styles";
import Axios from "../../../config/axios";
import Graphic from "../graphic";

const ArmEnergyPerHour = ({ referenceDates }) => {
  const [armEnergyByHour, setArmEnergyByHour] = useState([]);
  const [armEnergyReferenceDate, setArmEnergyReferenceDate] = useState(new Date());
  const [hours] = useState([
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ]);
  const [t] = useTranslation("global");
  const { patientId } = useParams();

  // Setting the reference date
  useEffect(() => {
    if (!referenceDates.length) return;
    const armProgressReferenceDate = referenceDates.filter((referenceDate) => referenceDate.REFERENCE_KEY === "armProgressReferenceDate");
    if (armProgressReferenceDate.length) {
      setArmEnergyReferenceDate(new Date(armProgressReferenceDate[0].REFERENCE_DATE));
    }
  }, [referenceDates]);

  // Fetch arm energy by date
  useEffect(() => {
    const referenceDateBody = {
      referenceDate: armEnergyReferenceDate,
    };
    Axios("post", `${WEB_SERVICE_MIMS}/arm-reference-date/get-energy-by-date/${patientId}`, referenceDateBody)
      .then(({ data }) => {
        const armEnergyByHour = data;
        const armEnergy = hours.map((hour) => armEnergyByHour[Number(hour)] ?? NaN);
        setArmEnergyByHour(armEnergy);
      })
      .catch((error) => {
        console.log("Get arm energy by date: ", error);
      });
  }, [patientId, armEnergyReferenceDate, hours]);

  const chartDataset = {
    labels: hours,
    datasets: [
      {
        label: t("wear_armEnergy"),
        data: armEnergyByHour,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
        spanGaps: true,
      },
    ],
  };

  return (
    <Graphic
      Title={t("wear_armEnergyPerHourPlot_title")}
      Type={Line}
      data={chartDataset}
      axisY={`${t("wear_armEnergy")} (m / s²)`}
      axisX={t("wear_armEnergyPerHourPlot_axisX")}
      graphicDescription={t("wear_armEnergyPerHourPlot_information")}
    >
      <RangeDatesDiv>
        <RangeDatesLabel>{t("wear_armEnergyPerHourPlot_dateRangeLabel")}</RangeDatesLabel>
        <DateInputDiv>
          <DateInput selected={armEnergyReferenceDate} onChange={(date) => setArmEnergyReferenceDate(date)} dateFormat={"dd/MM/yyyy"} />
        </DateInputDiv>
      </RangeDatesDiv>
    </Graphic>
  );
};

export default ArmEnergyPerHour;
